import { EventName } from '@lit/react';
import { SheriffEvent } from '../types';
export type SheriffEventName = EventName<SheriffEvent>;
